// extracted by mini-css-extract-plugin
module.exports = {"editIcon":"EditButton_editIcon__2flAn"};